/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export const navStyle = css`
  font-size: 18px;
  display: flex;
  justify-content: flex-end;
  gap: 40px;
`;

export const linkDefault = css`
  text-decoration: none;
  color: inherit;
`;
